import { useEffect } from "react";
import { getCookieConsent } from "@/hooks/useCookieConsent";

const GA_ID = "G-Y6CND43K3C";
const SCRIPT_ID = "ga-gtag-script";

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

function initConsentMode() {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window.gtag = function gtag(...args: any[]) {
    window.dataLayer.push(args);
  };
  // LGPD/GDPR — defaults negados até consentimento explícito
  window.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "denied",
    personalization_storage: "denied",
    security_storage: "granted",
    wait_for_update: 500,
  });
  window.gtag("js", new Date());
}

function loadGtagScript() {
  if (document.getElementById(SCRIPT_ID)) return;
  const s = document.createElement("script");
  s.id = SCRIPT_ID;
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.gtag("config", GA_ID, { anonymize_ip: true });
}

function updateConsent(analytics: boolean, functional: boolean) {
  if (!window.gtag) return;
  window.gtag("consent", "update", {
    analytics_storage: analytics ? "granted" : "denied",
    functionality_storage: functional ? "granted" : "denied",
    personalization_storage: functional ? "granted" : "denied",
  });
  if (analytics) loadGtagScript();
}

export default function GoogleAnalytics() {
  useEffect(() => {
    initConsentMode();

    const current = getCookieConsent();
    if (current) {
      updateConsent(current.choices.analytics, current.choices.functional);
    }

    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      if (!detail?.choices) return;
      updateConsent(!!detail.choices.analytics, !!detail.choices.functional);
    };
    window.addEventListener("cookie-consent-changed", handler);
    return () => window.removeEventListener("cookie-consent-changed", handler);
  }, []);

  return null;
}